import { useMemo } from "react";
import useSWR from "swr";

import { CountriesResponse } from "@organization/models/CountriesResponse";
import { Country } from "@organization/models/Country";

import { countryEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetCountries() {
  const url = countryEndpoints.countries();

  const { data, error, isLoading } = useSWR<CountriesResponse>(url, fetcher);

  return useMemo(
    () => ({
      countries: sortCountriesByName(data?.countries),
      isLoading,
      error
    }),
    [data, isLoading, error]
  );
}

function sortCountriesByName(countries: Country[] | undefined) {
  return countries?.sort((a, b) => a.displayName.localeCompare(b.displayName));
}
